import { reactive, readonly } from 'vue'

import { orderInit } from './modules/order/index'

/* --------------- 初始状态 --------------- */
const initState = { ...orderInit }
/* --------------- 纯 reducer --------------- */
function reducer(state = initState, action) {
  switch (action.type) {
    case 'STEP_CHANGE': {
      const { index } = action.payload
      const visited = state.visitedSteps.includes(index)
        ? state.visitedSteps
        : [...state.visitedSteps, index].sort((a, b) => a - b)
      return { ...state, currentStep: index, visitedSteps: visited }
    }

    case 'FIELD_CHANGE': {
      const { stepKey, fieldKey, value } = action.payload

      return {
        ...state,
        data: {
          ...state.data,
          [stepKey]: { ...state.data[stepKey], [fieldKey]: value },
        },
      }
    }

    case 'BATCH_UPDATE_FIELD': {
      const { updates } = action.payload
      const newData = { ...state.data }

      // 遍历传入的更新对象
      Object.keys(updates).forEach((key) => {
        if (newData[key]) {
          newData[key] = { ...newData[key], ...updates[key] }
        }
      })

      return {
        ...state,
        data: newData,
      }
    }

    case 'RESET_ALL_DATA': {
      // 完全重置所有数据到初始状态
      return { ...orderInit, currentStep: 0 }
    }


    default:
      return state
  }
}

/* --------------- 单例 Store --------------- */
const _state = reactive(reducer(undefined, { type: '@@INIT' }))

export const miniStore = {
  // 只读视图
  state: readonly(_state),

  // 唯一写入口
  dispatch(action) {
    const nextState = reducer(_state, action)
    Object.keys(nextState).forEach((k) => {
      _state[k] = nextState[k] // 保持响应式
    })
  },
}
